export const USER_ROLES = {
  admin: "admin",
} as const;

export type USER_ROLE = (typeof USER_ROLES)[keyof typeof USER_ROLES];
